module.exports = __webpack_public_path__ + "img/banner.2fe90a3c.png";